module.exports = __webpack_public_path__ + "static/mask_lo_098-c1de98700c59758d0833b5554b62163c.jpg";